import { InputNumber, InputNumberProps } from 'antd'
import { hasValue } from '../../helpers/nullable'
import { roundToPrecision } from '../../helpers/math'

export type Props = {
  value?: number
  onChange?: (value: number | undefined) => void
  placeholder?: string
  style?: React.CSSProperties
  min?: number
  max?: number
  addonAfter?: InputNumberProps['addonAfter']
  onPressEnter?: InputNumberProps['onPressEnter']
}

export const DollarInput = (props: Props) => {
  const handleChange = (inputValue: number | null) => {
    props.onChange?.(hasValue(inputValue) ? Math.round(inputValue * 100) : undefined)
  }

  return <InputNumber
    {...props}
    value={hasValue(props.value) ? roundToPrecision(props.value / 100, 2) : null}
    onChange={handleChange}
    step={1}
    addonBefore="$"
    precision={2}
    min={hasValue(props.min) ? roundToPrecision(props.min / 100, 2) : undefined}
    max={hasValue(props.max) ? roundToPrecision(props.max / 100, 2) : undefined}
  />
}

export default DollarInput
